import {
  DatePicker,
  Input,
  Popconfirm,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { DeleteTwoTone, EyeTwoTone } from "@ant-design/icons";
import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import {
  deleteMessageById,
  getMessagesList,
  selectMessages,
  toggleReadMessageById,
} from "../../store/slices/messageSlice";

import FullMessagePopup from "./FullMessagePopup";

const { Search } = Input;
const { Text } = Typography;

const Messages = () => {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeItem, setActiveitem] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [pagination, setPagination] = useState({
    pageSizeOptions: ["10", "20", "50"],
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const messageList = useSelector(selectMessages);
  const dispatch = useDispatch();

  const fetchData = (pagination, searchTerm, startDate, endDate) => {
    setLoading(true);
    dispatch(
      getMessagesList(
        startDate?.format("YYYY-MM-DD 00:00:00"),
        endDate?.format("YYYY-MM-DD 23:59:00"),
        searchTerm ?? "",
        pagination.current,
        pagination.pageSize,
        (totalData) => {
          setPagination({ ...pagination, total: totalData });
          setLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    fetchData(pagination, searchTerm);
  }, []);

  const handleTableChange = (pagination) => {
    fetchData(pagination, searchTerm, startDate, endDate);
  };

  const handleDelete = (item) => {
    setConfirmLoading(true);
    dispatch(
      deleteMessageById(item.id, () => {
        setConfirmLoading(false);
      })
    );
  };

  const changeStatus = (item) => {
    setConfirmLoading(true);
    dispatch(
      toggleReadMessageById(item.id, () => {
        setConfirmLoading(false);
      })
    );
  };

  const columns = [
    {
      title: "Received on",
      dataIndex: "dates",
      render: (_, record) => {
        return <p> {new Date(_.created_at).toLocaleDateString()}</p>;
      },
      width: "150px",
    },
    {
      title: "From",
      dataIndex: "name",
      render: (_, record) => {
        const { name, email, phone } = record;
        return (
          <Space direction="vertical" size={2}>
            {name && <span>{name}</span>}
            {email && <span>{email}</span>}
            {phone && <span>{phone}</span>}
          </Space>
        );
      },
      width: "250px",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      render: (_, record) => {
        let message = _;

        if (_.length > 30) {
          message = _.slice(0, 30 - 3) + "...";
        }

        return <>{message}</>;
      },
      width: "250px",
    },
    {
      title: "Message",
      dataIndex: "message",
      render: (_, record) => {
        let message = _;

        if (_.length > 50) {
          message = _.slice(0, 50 - 3) + "...";
        }

        return <>{message}</>;
      },
    },
    {
      title: "Status",
      dataIndex: "isRead",
      render: (_, record) => {
        return (
          <>
            <Space>
              {_ ? <Tag>Already viewed</Tag> : <Tag color="green">New</Tag>}
              {/* <Popconfirm
                title={`Are you sure want to mark this message as ${
                  _ ? "unread" : "read"
                }?`}
                onConfirm={() => changeStatus(record)}
              >
                <Button style={{ width: "150px" }} type="default">
                  {_ ? "Mark as unread" : "Mark as read"}
                </Button>
              </Popconfirm> */}
            </Space>
          </>
        );
      },
      width: "150px",
    },
    {
      title: "Actions",
      dataIndex: "name",
      width: "100px",
      render: (_, record) => {
        return (
          <Space style={{ justifyContent: "center", width: "100%" }}>
            <EyeTwoTone
              title="View message"
              twoToneColor="#1890ff"
              style={{
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={() => {
                setActiveitem(record);
                setIsModalVisible(true);

                if (!record.isRead) {
                  changeStatus(record);
                }
              }}
            />
            <Popconfirm
              confirmLoading={confirmLoading}
              title="Are you sure want to delete this message?"
              onConfirm={() => handleDelete(record)}
              placement="topRight"
            >
              <DeleteTwoTone
                title="Delete"
                twoToneColor="#ff0000"
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                  marginLeft: "4px",
                }}
              />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <h2 style={{ fontWeight: "bold" }}>Messages</h2>
      {isModalVisible && (
        <FullMessagePopup closePopup={setIsModalVisible} item={activeItem} />
      )}
      <Space
        style={{
          width: "100%",
          marginBottom: "15px",
          justifyContent: "flex-end",
        }}
        size={10}
        direction="horizontal"
        align="end"
      >
        <Space direction="vertical">
          <Text>Start Date:</Text>
          <DatePicker
            format="MM/DD/YYYY"
            value={startDate}
            placeholder="Select start date"
            onChange={(value) => {
              setStartDate(value);
              fetchData(pagination, searchTerm, value, endDate);
            }}
            disabledDate={(current) => {
              return moment().add(0, "days") < current;
            }}
          />
        </Space>
        <Space direction="vertical">
          <Text>End Date:</Text>
          <DatePicker
            format="MM/DD/YYYY"
            defaultValue={startDate}
            placeholder="Select end date"
            onChange={(value) => {
              setEndDate(value);
              fetchData(pagination, searchTerm, startDate, value);
            }}
            disabledDate={(current) => {
              return moment().add(0, "days") < current || startDate > current;
            }}
          />
        </Space>
        <Space direction="vertical">
          <Text>Search:</Text>
          <Search
            allowClear
            placeholder="Search"
            onSearch={(value) => {
              setSearchTerm(value);
              fetchData(pagination, value, startDate, endDate);
            }}
            enterButton
            style={{ width: "350px" }}
          />
        </Space>
      </Space>
      <Table
        dataSource={messageList}
        columns={columns}
        loading={loading}
        bordered
        rowKey="id"
        pagination={pagination}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Messages;
